import React from 'react';
import Modal from 'react-awesome-modal';
import {actionMultiple} from '../../../Services/IBS/IbsService';

export const InProcessMandateMultiActionModal = ({multiActionModalSettings, setMultiActionModalSettings, mandates}) => {
    return (<Modal
        width="1300"
        className="testClass"
        effect="fadeInDown"
        visible={multiActionModalSettings.show}
    >
        <div className="commentModal multipleModal" id="multipleModal">
            <h3><i className="fa fa-edit"></i> Confirm running multiple actions</h3>
            <hr/>
            <div className="tableContainer">
                <table className="NoAction">
                    <thead>
                    <tr>
                        <th style={{width: '8%'}}>Mandate ID</th>
                        <th style={{width: '8%'}}>AgrID</th>
                        <th style={{width: '18%'}}>Asset</th>
                        <th style={{width: '16%'}}>Style</th>
                        <th style={{width: '22%'}}>Manager</th>
                        <th style={{width: '22%'}}>Fund</th>
                        <th style={{width: '6%'}}>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {mandates?.length > 0 ? mandates.map(selectedRow => {
                        if (selectedRow.isSelected) {
                            return (<tr className={multiActionModalSettings.mode === 'add' ? 'addRow' : 'removeRow'}>
                                <td>{selectedRow.statusId <= 2 && selectedRow.mandateId > 0 ? selectedRow.mandateId : 'NA'}</td>
                                <td>{selectedRow.statusId <= 2 ? selectedRow.agrId : ''}</td>
                                <td>{selectedRow.statusId <= 2 ? selectedRow.asset : ''}</td>
                                <td>{selectedRow.statusId <= 2 ? selectedRow.style : ''}</td>
                                <td>{selectedRow.managerName}</td>
                                <td>{selectedRow.fundName}</td>
                                <td>{multiActionModalSettings.mode === 'add' ? 'Add' : 'Remove'}</td>
                            </tr>);
                        }
                    }) : null}
                    </tbody>
                </table>
            </div>
            <button type="button" className="btn btn-close green" onClick={() => {
                let parsedInProcess = mandates.filter(template => template.isSelected).map(template => ({
                    "rowId": template.rowId,
                    "mandateId": template.mandateId,
                    "action": multiActionModalSettings.mode === 'add' ? "add" : "remove"
                }));
                actionMultiple(parsedInProcess);
                setMultiActionModalSettings({show: false, mode: ''})
            }}>Confirm
            </button>
            <button type="button" 
                    className="btn btn-close orange" 
                    onClick={() => setMultiActionModalSettings({show: false, mode: ''})}>Cancel</button>
        </div>
    </Modal>)
}